// extracted by mini-css-extract-plugin
export default {"GhostLine":"GhostLine-styles__GhostLine__SUc3I","shimmer":"GhostLine-styles__shimmer__wx8EQ"};